// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"62":"8b6a60f5","488":"9fe4aa43","689":"8b6a60f5","732":"9fe4aa43"}[chunkId] + ".chunk.css";
};